/** How to connect an AI client to the platform (backend/app/mcp). */

export const SERVER_NAME = 'hydrodiagnostics'

/** The command that adds the platform to Claude Code, whether in a terminal,
 *  the VS Code add-on or the Desktop Code tab. Sign-in happens on first use. */
export function claudeCodeCommand(url: string): string {
  return `claude mcp add --transport http --scope user ${SERVER_NAME} ${url}`
}

export type CallOutcome = 'ok' | 'refused' | 'error'

/** What a recorded call's outcome is called on screen. */
export function outcomeLabel(outcome: CallOutcome): string {
  if (outcome === 'ok') return 'Done'
  return outcome === 'refused' ? 'Refused' : 'Failed'
}
